import React from 'react'
import { Box, Button, Container, Stack } from '@mui/material'
import desktoplogo from '../assets/logo-mobile-ldir.svg'
import CloseIcon from '@mui/icons-material/Close'
import { FormattedMessage } from 'react-intl'

interface Props {
    closeFunction: Function
}

const HeaderCloseLine = ({ closeFunction }: Props) => {
    return (
        <Container sx={{ backgroundColor: 'common.white' }}>
            <Stack
                direction='row'
                justifyContent='space-between'
                sx={{
                    width: '100%',
                    padding: '0.5rem 0',
                }}>
                <Box sx={{ justifyContent: 'flex-start' }}>
                    <Box
                        component='img'
                        sx={{
                            height: '2rem',
                        }}
                        alt='Logo'
                        src={desktoplogo}
                    />
                </Box>
                <Button
                    variant='text'
                    sx={{
                        fontSize: '1rem',
                        zIndex: '5',
                    }}
                    onClick={() => closeFunction(false)}
                    endIcon={<CloseIcon fontSize='medium' />}>
                    <FormattedMessage id={'component.header.close'} />
                </Button>
            </Stack>
        </Container>
    )
}
export default HeaderCloseLine
